import { render, staticRenderFns } from "./WooEntry.vue?vue&type=template&id=596a1bce&scoped=true&"
import script from "./WooEntry.vue?vue&type=script&lang=js&"
export * from "./WooEntry.vue?vue&type=script&lang=js&"
import style0 from "./WooEntry.vue?vue&type=style&index=0&id=596a1bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a1bce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
